import React from 'react';
import { Box, Typography } from '@mui/material';

type StepHeaderProps = {
    step: number;
    totalSteps: number;
    title: string;
};

const StepHeader = ({ step, totalSteps, title }: StepHeaderProps) => {
    return (
        <>
            <Box sx={styleSheet.header}>
                <Typography sx={styleSheet.title}>
                    Become a Content Creator
                </Typography>
                <Box display={"flex"} gap={4} >
                    <Typography sx={styleSheet.step}>
                        Step {step}: {title}
                    </Typography>
                    <Typography variant="subtitle2" sx={styleSheet.progress}>
                        {step}/{totalSteps}
                    </Typography>
                </Box>

            </Box>
        </>

    );
};

export default StepHeader;

const styleSheet = {
    header: {
        padding: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        // borderBottom: '2px solid #e0e0e0',
        // paddingBottom: 2,
        // marginBottom: 2,
    },
    title: {
        fontWeight: 700,
        fontSize: 18,
        color: '#797979',
    },
    step: {
        fontWeight: 500,
        fontSize: 18,
        color: '#797979',
    },
    progress: {
        fontWeight: 500,
        fontSize: 18,
        color: '#797979',
    },
}